import styled from "@emotion/styled";
import {
  Container,
  FlexRow,
  H2,
  Link,
  SiteContainer,
  TagLink,
  TagList,
  Text,
} from "atoms";
import { featureFlags } from "config";
import betaFlagSrc from "assets/images/beta-flag.svg";
import discoverOnTheHugSrc from "assets/images/discover-on-the-hug.svg";
import keepExploringSrc from "assets/images/keep-exploring.svg";
import raffleTicket from "assets/images/raffle-ticket-raffle.png";
import { useAuth } from "features/auth";
import {
  FeaturedArtists,
  FeaturedProjects,
  HomeHero,
  HomeInclusiverse,
  MintingNow,
  // MintingSoon,
} from "features/hub";
import { founderAttributes, missionOrCauses } from "features/reviewable";
import { PlatformStats } from "features/system";
import { useRaffleItems } from "features/pointsStore";

function HubHome() {
  const { user } = useAuth();
  // const hasHugPass = user?.hugTokenIds;
  const isHugger = user?.utilities.includes("Hugger");
  const isReviewer = user?.completedLevel1Training;
  const isModerator = user?.completedLevel2Training;
  // const isCuratorLvl3 = user?.completedLevel3Training;

  const { data: raffles } = useRaffleItems();

  const currantRaffle = isHugger ? raffles?.current : undefined;

  let authStatus = "";
  if (isModerator) {
    authStatus = "moderator";
  } else if (isReviewer) {
    authStatus = "reviewer";
  } else if (isHugger) {
    authStatus = "hugger";
  } else if (user) {
    authStatus = "user";
  } else {
    authStatus = "anon";
  }
  return (
    <>
      {featureFlags.enableDynamicHomePage ? (
        <HeaderWrapper>
          <Header>
            <HomeHero authStatus={authStatus} />
          </Header>
        </HeaderWrapper>
      ) : (
        <header>
          <Container width="md">
            <SFlexRow>
              <HeaderImgWrapper as="h2">
                <HeaderImg
                  src={discoverOnTheHugSrc}
                  alt="Discover on the HUG."
                />
                <BetaFlag src={betaFlagSrc} alt="Now in Beta." />
              </HeaderImgWrapper>

              {currantRaffle ? (
                <HeroPromo>
                  <div>
                    <H2 size="xxs" as={Text}>
                      HUG Points Raffle
                    </H2>
                    <Text as={H2} size="md">
                      {currantRaffle.title}
                    </Text>
                    <Link variant="primary" size="xs" to="/redeem-hug-points">
                      Enter Raffle
                    </Link>
                  </div>
                  <figure>
                    <img
                      src={currantRaffle.image.url600}
                      alt={currantRaffle.title}
                    />
                    <RaffleTicket
                      src={raffleTicket}
                      alt=""
                      aria-hidden="true"
                    />
                  </figure>
                </HeroPromo>
              ) : (
                <div>
                  <Text>
                    HUG is an inclusive social curation community
                    that&nbsp;helps you discover and share hug-worthy
                    NFT&nbsp;creators and&nbsp;communities.
                  </Text>
                  {authStatus === "user" ? (
                    <Link
                      variant="gradient"
                      size="md"
                      href="https://opensea.io/collection/hugpass"
                    >
                      Buy a HUG Pass
                    </Link>
                  ) : (
                    <Link variant="gradient" size="md" to="/search">
                      Explore
                    </Link>
                  )}
                </div>
              )}
            </SFlexRow>
          </Container>
        </header>
      )}
      <SiteContainer>
        <Main>
          {featureFlags.enableDynamicHomePage && !isHugger && (
            <HomeInclusiverse authStatus={authStatus} />
          )}

          <HubSection>
            <FeaturedArtists />
          </HubSection>

          {featureFlags.enableTrendingSection && (
            <HubSection>
              <PlatformStats />
            </HubSection>
          )}

          <HubSection>
            <FeaturedProjects />
          </HubSection>

          <HubSection>
            <MintingNow />
          </HubSection>

          <HubSection textCenter>
            <Container width="sm">
              <H2>Explore By Founder Attributes</H2>
              <TagList justify="center">
                {founderAttributes.map((tag) => (
                  <TagLink key={tag} tag={tag} variant="founderAttributes" />
                ))}
              </TagList>
            </Container>
          </HubSection>

          {/* <HubSection>
            <MintingSoon />
          </HubSection> */}

          <HubSection textCenter>
            <Container width="sm">
              <H2>Explore By Mission/Cause</H2>
              <TagList justify="center">
                {missionOrCauses.map((tag) => (
                  <TagLink key={tag} tag={tag} variant="missionOrCause" />
                ))}
              </TagList>
            </Container>
          </HubSection>

          {featureFlags.enableKeepExploring && (
            <HubSection>
              <Img src={keepExploringSrc} alt="Keep Exploring" />
            </HubSection>
          )}
        </Main>
      </SiteContainer>
    </>
  );
}
const SFlexRow = styled(FlexRow)(({ theme }) => ({
  paddingTop: "calc(3rem + 3vw)",
  textAlign: "center",
  justifyContent: "center",
  flexDirection: "column",
  gap: "calc(1.5rem + 4vw)",
  "&>*": {
    maxWidth: "550px",
  },
  img: {
    maxWidth: 250,
    margin: "0 auto 1em auto",
    display: "block",
  },
  [theme.breakpoints.tablet]: {
    flexDirection: "row",
    flexwrap: "wrap",
    textAlign: "left",
    "&>*": {
      flex: "1",
      maxWidth: "550px",
    },
    img: {
      margin: 0,
      flex: "0 0 300px",
    },
  },
}));
const headerBottomHeight = "calc(15em + 10vw)";
const HeaderWrapper = styled.div(({ theme }) => ({
  paddingTop: 0,
  position: "relative",
  backgroundImage: `linear-gradient(to right, ${theme.colors.yellow} 0%, ${theme.colors.green} 100%)`,
  "&::after": {
    content: "''",
    position: "absolute",
    left: 0,
    right: 0,
    top: "100%",
    height: headerBottomHeight,
    backgroundImage: `linear-gradient(to bottom , transparent 0%, white 100%), linear-gradient(to right, ${theme.colors.yellow} 0%, ${theme.colors.green} 100%)`,
    pointerEvents: "none",
    zIndex: 1,
  },
  "&+*": {
    paddingTop: "5rem",
    position: "relative",
    zIndex: 3,
  },
}));
const Header = styled(Container)({
  overflowX: "hidden",
  position: "relative",
  zIndex: 1,
}).withComponent("header");
const Main = styled.main(({ theme }) => ({
  // "section+section": {
  // paddingTop: "calc(2rem + 5vw)",
  // },
}));

const HeaderImgWrapper = styled.div({
  margin: "0",
  position: "relative",
  maxWidth: 250,
  flex: "1 1 50px",
  "@media (min-width: 800px)": {
    flex: "1 1 200px",
  },
});
const HeaderImg = styled.img({
  display: "block",
  width: "100%",
  maxWidth: "100%",
  "@media (max-width: 799px)": {
    marginBottom: "1rem",
    flex: "0 0 250px",
    maxWidth: "250px",
  },
});
const BetaFlag = styled.img({
  left: "90%",
  position: "absolute",
  top: "25%",
  transformOrigin: "center",
  width: 50,
  transform: "rotate(-18deg)",
  "@media (min-width: 800px)": {
    width: 65,
  },
});

const Img = styled.img({
  display: "block",
  margin: "0 auto",
});

const HubSection = styled.section<{ textCenter?: boolean }>(
  ({ textCenter = false, theme }) => ({
    marginBottom: "calc(3.5rem + 5vw)",
    textAlign: textCenter ? "center" : "left",
  })
);
const HeroPromo = styled.div(({ theme }) => ({
  alignItems: "center",
  backgroundColor: "white",
  borderRadius: theme.borderRadius.md,
  boxShadow: theme.boxShadow.light,
  display: "flex",
  gridArea: "image",
  gap: "1em",
  padding: "1rem",
  flex: "1 1 170px",
  h2: {
    textAlign: "left",
  },
  "&>div": {
    flex: "1 0 50%",
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "start",
    gap: 10,
  },
  "&>figure": {
    flex: "1 1 25%",
    position: "relative",
  },
  img: {
    borderRadius: theme.borderRadius.sm,
    display: "block",
    maxWidth: "100%",
  },
  "h2, p": {
    margin: 0,
  },
  "@media (min-width: 831px)": {
    margin: "0 2rem",
    maxWidth: "450px",
  },
}));
const RaffleTicket = styled.img({
  position: "absolute",
  bottom: 0,
  right: 0,
  width: 100,
  transform: "translate(30%, 45%) rotate(-4deg)",
});

export { HubHome, HubSection };
